"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.createMuiChipOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette, typography = _a.typography;
    return ({
        root: __assign({ height: spacing(6), borderRadius: shape.borderRadius, backgroundColor: styles_1.fade(palette.text.primary, palette.type === "dark" ? 0.18 : 0.12) }, typography.overline),
    });
};
//# sourceMappingURL=MuiChip.js.map